module.exports = __webpack_public_path__ + "img/x15.aa07a4b1.jpg";